import * as React from "react";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { Close, Check, ForwardToInbox } from "@mui/icons-material";

import { TextAvatar } from "../../../components";
import { useAlert, useAxios } from "../../../hooks";
import convertDateTimeUTC from "../../../utils/convertUTC";
import { colors, TextFourteenBlack } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 40px;
  width: 40px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ usersList }) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(
    Array(usersList.length).fill(true)
  );

  function handleResendEmail(emailId, index) {
    setLoading((prev) => {
      let array = [...prev];
      array[index] = false;

      return array;
    });

    axios({
      url: "/send/unverified/users/email",
      method: "POST",
      data: { email: emailId },
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        dispatch(alert({ type: "success", message: response.data }));
      }
      setLoading((prev) => {
        let array = [...prev];
        array[index] = true;

        return array;
      });
    });
  }

  return (
    <TableContainer
      sx={{ maxHeight: "90%", borderRadius: "10px" }}
      component={Paper}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            <StyledTableCell />

            <StyledTableCell>User</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>Registration Date</StyledTableCell>
            <StyledTableCell>Email Verification</StyledTableCell>
            <StyledTableCell>Admin Verification</StyledTableCell>
            <StyledTableCell>Brand Created</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {usersList.map((user, index) => (
            <StyledTableRow>
              <Fragment>
                <StyledTableCell component="th" scope="row">
                  <TextAvatar
                    size={{
                      height: "30px",
                      width: "30px",
                    }}
                    userName={
                      user.given_name.replace(/_/g, " ") +
                      " " +
                      user.family_name
                    }
                  />{" "}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {user.given_name.replace(/_/g, " ") + " " + user.family_name}
                  <TextFourteenBlack>{user.display_name}</TextFourteenBlack>
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {user.email?.length > 20
                    ? user.email?.substr(0, 20) + "..."
                    : user.email || "-"}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {convertDateTimeUTC(user.created_at)}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {!user.is_email_verified ? (
                    <Close
                      sx={{
                        color: colors.error,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}

                  {user.is_email_verified ? (
                    <Check
                      sx={{
                        color: colors.green,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {!user.account_status ? (
                    <Close
                      sx={{
                        color: colors.error,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {user.account_status ? (
                    <Check
                      sx={{
                        color: colors.green,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </StyledTableCell>

                <StyledTableCell>
                  {!user.is_brand_created ? (
                    <Close
                      sx={{
                        color: colors.error,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {user.is_brand_created ? (
                    <Check
                      sx={{
                        color: colors.green,
                        borderRadius: "5px",
                        border: "3px solid",
                        fontSize: "x-large",
                        marginLeft: "45px",
                        marginTop: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </StyledTableCell>

                <StyledTableCell style={{ display: "flex" }}>
                  <Tooltip title="Resend Email">
                    {!loading[index] ? (
                      <CircularProgress />
                    ) : !user.is_email_verified ? (
                      <Icon
                        style={{
                          border: `1px solid ${colors.green}`,
                          color: colors.green,
                        }}
                      >
                        <ForwardToInbox
                          style={{
                            color: colors.green,
                            height: "25px",
                            width: "25px",
                          }}
                          onClick={() => handleResendEmail(user.email, index)}
                        />
                      </Icon>
                    ) : (
                      <div
                        style={{
                          height: "39px",
                          width: "39px",
                        }}
                      />
                    )}
                  </Tooltip>
                </StyledTableCell>
              </Fragment>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
